import React from 'react'
import * as RT from '../../../constants/Routing'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
// import LoadingGif from '../../../lib/images/loading.gif'
import UserCard from '../ProfileCard'
import * as SG from '../../../constants/AppSettings'
import Modal from '../../App/Modal'
import ReactDOM from 'react-dom'
// import AutoKana from 'react-auto-kana'
import historykana from 'historykana'
export default class Component extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      "bank[bank_number]": '',
      "bank[branch_number]": '',
      "bank[account_number]": '',
      "bank[account_holder_name]": '',
      "bank[account_holder_type]": 'individual',
      "account[postal_code]": '',
      "account[kanji_state]": '',
      stateHistory: [],
      "account[kanji_city]": '',
      cityHistory: [],
      "account[kanji_town]": '',
      townHistory: [],
      "account[kanji_line1]": '',
      line1History: [],
      "account[kanji_line2]": '',
      line2History: [],
      firstNameHistory: [],
      lastNameHistory: [],
      "account[kana_state]": '',
      "account[kana_city]": '',
      "account[kana_town]": '',
      "account[kana_line1]": '',
      "account[kana_line2]": '',
      "account[kanji_first_name]": '',
      "account[kanji_last_name]": '',
      "account[kana_first_name]": '',
      "account[kana_last_name]": '',
      "file": '',
      confirmStripe: false,
      stripe: null,
      openModal: false,
      modalMessage: '',
      modalHeader: '',
      confirmModal: false,
      modalPreviewSrc: '',
      formStep: 1,
      bankToken: null,
      lastKeyPush: null
    }
  }

  windowSizeFetch = () => {
    const windowHeight = window.innerHeight
    let windowHeightPx
    if (windowHeight > document.querySelector('#panel .wrap').scrollHeight + 40) {
      windowHeightPx = `${windowHeight + 40}px`
      document.body.style.height = windowHeightPx
      document.querySelector('#root').style.height = windowHeightPx
      document.querySelector('.App').style.height = windowHeightPx
      document.querySelector('#panel').style.height = windowHeightPx
    } else {
      windowHeightPx = `auto`
      document.body.style.height = windowHeightPx
      document.querySelector('#root').style.height = windowHeightPx
      document.querySelector('.App').style.height = windowHeightPx
      document.querySelector('#panel').style.height = windowHeightPx
    }
  }

  isHiragana = (str) => {
    str = (str == null) ? "" : str
    if (str.match(/^[ぁ-んー　0-9０-９\-ー]*$/)) {
      return true
    } else {
      return false
    }
  }

  isPostcode = (postcode) => {
    if ((postcode.match(/^\d{7}$/))) {
      return true
    } else { return false }
  }

  isNumber = (num) => {
    if ((num.match(/^\d+$/))) {
      return true
    } else {
      return false
    }
  }

  isAllHiragana = () => {
    const hiraganas = document.querySelectorAll('[data-hiragana=true]')
    const count = hiraganas.length
    let isAllHiragana = true
    for (let index = 0; index < count; index++) {
      const element = hiraganas[index]
      const isHiragana = this.isHiragana(element.value)
      if (!isHiragana) {
        isAllHiragana = false
        break
      }
    }
    return isAllHiragana
  }

  isAllNum = () => {
    const nums = document.querySelectorAll('[data-number=true]')
    const count = nums.length
    let isAllNum = true
    for (let index = 0; index < count; index++) {
      const element = nums[index]
      const isNum = this.isNumber(element.value)
      if (!isNum) {
        isAllNum = false
        break
      }
    }
    return isAllNum
  }

  openModal = () => {
    this.setState({
      openModal: true
    })
  }
  

  closeModal = () => {
    this.setState({
      openModal: false,
      confirmModal: false,
    })
  }

  openConfirmModal = () => {

    this.setState({
      openModal: true,
      confirmModal: true
    })
  }

  componentWillMount = () => {
    this.props.getBankInfo()
  }

  componentWillReceiveProps = (nextProps) => {
    // console.log('will receive', nextProps.UserBank.userAccount.status)

    if (nextProps.UserBank.userAccount && nextProps.UserBank.userAccount.status) {
      let collectStep = 1
      switch (nextProps.UserBank.userAccount.status) {
        case 'unapplied':
          collectStep = 1
          break;
        case 'pending':
          collectStep = 4
          break;
        case 'verified':
          collectStep = 5
          break;
        case 'rejected':
          collectStep = 1
          break;
        default:
          collectStep = 1
          break;
      }
      // console.log('nextProps', nextProps.UserBank.userAccount.status, collectStep)

      if (this.state.formStep !== collectStep) {
        this.setState({ formStep: collectStep, openModal: false})
      }
    }
  }

  componentWillUnmount = () => {
    this.props.getBankInfoReset()
  }

  componentDidMount = () => {
    if (window.Stripe) {
      this.setState({ stripe: window.Stripe(SG.STRIPE_API_PUBLISH_KEY)})
    } else {
      document.getElementById('stripe-js').addEventListener('load', () => {
        this.setState({ stripe: window.Stripe(SG.STRIPE_API_PUBLISH_KEY)})
      })
    }
    // if (window.Zip) {
    //   window.Zip.x()
    // }
    
    // window.YubinBango()
  }

  // onBlurZipcode = () => {
  //   this.setState({
  //     "account[kanji_state]": document.getElementById('pref').value,
  //     "account[kanji_city]": document.getElementById('city').value,
  //     "account[kanji_town]": document.getElementById('area').value,
  //     "account[kanji_line1]": document.getElementById('addr').value,
  //   })
  // }

  componentDidUpdate = () => {
    if (this.state.confirmModal && this.state.formStep == 3) {
      const fileInput = document.querySelector('.thumb-field')
      const previewImage = document.querySelector('.preview-image-confirm')
      if (previewImage) {
        if (!fileInput.files.length) {
          previewImage.classList.add('d-none')
          previewImage.src = ''
        } else {

          let fileReader = new FileReader()

          fileReader.onload = () => {
            previewImage.src = fileReader.result
            this.windowSizeFetch()
          }
          fileReader.readAsDataURL(fileInput.files[0])
          fileReader.onload()
        }
      }
    }
    this.windowSizeFetch()
  }

  

  generateToken = () => {
    let country, currency
    if (process.env.NODE_ENV === 'production') {
      country = 'JP'
      currency = 'jpy'
    }else{
      country = 'US'
      currency = 'usd'
    }
    this.state.stripe.createToken('bank_account', {
      country: country,
      currency: currency,
      routing_number: this.state['bank[bank_number]']+this.state['bank[branch_number]'],
      account_number: this.state['bank[account_number]'],
      account_holder_name: this.state['bank[account_holder_name]'],
      account_holder_type: this.state['bank[account_holder_type']
    }).then((res) => {
      if (!!res.error) {
        let errorMsg
        switch (res.error.code) {
          case 'account_number_invalid':
            errorMsg = '口座番号が不正な値です'
            break;
          case 'bank_account_unusable':
            errorMsg = 'ご指定の口座は本アプリケーションでは使用できません'
            break;
          case 'routing_number_invalid':
            errorMsg = '銀行番号と支店番号の組み合わせが不正な値です'
            break;
          case 'parameter_invalid_empty':
            errorMsg = '必要な口座情報が入力されていません'
            break;
          default:
            errorMsg = '口座情報が正しく入力されていないか、登録できない銀行口座のようです'
            break;
        }
        this.setState({ modalMessage: errorMsg, openModal: true, modalHeader: '口座情報にエラーがあります', confirmModal: false })
        return false
      } else {
        this.closeModal()
        this.setState({ bankToken: res.token.id, formStep: 2})
      }
    }).catch(res => {
    })
  }

  checkAllEnter = () => {
    // 入力チェック
    switch (this.state.formStep) {
      case 1:
        if (
          !!this.state["bank[bank_number]"] &&
          !!this.state["bank[branch_number]"] &&
          !!this.state["bank[account_number]"] &&
          !!this.state["bank[account_holder_name]"] &&
          !!this.state["bank[account_holder_type]"] &&
          this.isAllHiragana() &&
          this.isAllNum()
        ) {
          return true
        } else {
          return false
        }
        break;
      case 2:
        if (
          !!this.state["bank[bank_number]"] &&
          !!this.state["bank[branch_number]"] &&
          !!this.state["bank[account_number]"] &&
          !!this.state["bank[account_holder_name]"] &&
          !!this.state["bank[account_holder_type]"] &&
          !!this.state["account[postal_code]"] &&
          !!this.state["account[kanji_state]"] &&
          !!this.state["account[kanji_city]"] &&
          !!this.state["account[kanji_line1]"] &&
          !!this.state["account[kana_state]"] &&
          !!this.state["account[kana_city]"] &&
          !!this.state["account[kana_line1]"] &&
          this.isAllHiragana() &&
          this.isPostcode(this.state["account[postal_code]"]) &&
          this.isAllNum()
        ) {
          return true
        } else {
          return false
        }
        break;
      case 3:
        if (
          !!this.state["bank[bank_number]"] &&
          !!this.state["bank[branch_number]"] &&
          !!this.state["bank[account_number]"] &&
          !!this.state["bank[account_holder_name]"] &&
          !!this.state["bank[account_holder_type]"] &&
          !!this.state["account[postal_code]"] &&
          !!this.state["account[kanji_state]"] &&
          !!this.state["account[kanji_city]"] &&
          !!this.state["account[kanji_line1]"] &&
          !!this.state["account[kana_state]"] &&
          !!this.state["account[kana_city]"] &&
          !!this.state["account[kana_line1]"] &&
          !!this.state["account[kanji_first_name]"] &&
          !!this.state["account[kanji_last_name]"] &&
          !!this.state["account[kana_first_name]"] &&
          !!this.state["account[kana_last_name]"] &&
          !!this.state["file"] &&
          this.isAllHiragana() &&
          this.isPostcode(this.state["account[postal_code]"]) &&
          this.isAllNum() && 
          !!this.state.confirmStripe
        ) {
          return true
        } else {
          return false
        }
        break;
      default:
        break;
    }

  }

  submitAction = (token) => {
    if (!!token) {
      const accountForm = document.querySelector('.account-form')
      const fileData = new FormData()
      fileData.append("file", document.querySelector('.account-document-input').files[0])
      // const accountData = new FormData()
      
      // accountData.append("account[postal_code]", this.state["account[postal_code]"])
      // accountData.append("account[kanji_state]", this.state["account[kanji_state]"])
      // accountData.append("account[kanji_city]", this.state["account[kanji_city]"])
      // accountData.append("account[kanji_town]", this.state["account[kanji_town]"])
      // accountData.append("account[kanji_line1]", this.state["account[kanji_line1]"])
      // accountData.append("account[kanji_line2]", this.state["account[kanji_line2]"])
      // accountData.append("account[kana_state]", this.state["account[kana_state]"])
      // accountData.append("account[kana_city]", this.state["account[kana_city]"])
      // accountData.append("account[kana_town]", this.state["account[kana_town]"])
      // accountData.append("account[kana_line1]", this.state["account[kana_line1]"])
      // accountData.append("account[kana_line2]", this.state["account[kana_line2]"])
      // accountData.append("account[kanji_first_name]", this.state["account[kanji_first_name]"])
      // accountData.append("account[kanji_last_name]", this.state["account[kanji_last_name]"])
      // accountData.append("account[kana_first_name]", this.state["account[kana_first_name]"])
      // accountData.append("account[kana_last_name]", this.state["account[kana_last_name]"])

      const accountData = {
        postal_code: this.state["account[postal_code]"],
        kanji_state: this.state["account[kanji_state]"],
        kanji_city: this.state["account[kanji_city]"],
        kanji_town: this.state["account[kanji_town]"],
        kanji_line1: this.state["account[kanji_line1]"],
        kanji_line2: this.state["account[kanji_line2]"],
        kana_state: this.state["account[kana_state]"],
        kana_city: this.state["account[kana_city]"],
        kana_town: this.state["account[kana_town]"],
        kana_line1: this.state["account[kana_line1]"],
        kana_line2: this.state["account[kana_line2]"],
        kanji_first_name: this.state["account[kanji_first_name]"],
        kanji_last_name: this.state["account[kanji_last_name]"],
        kana_first_name: this.state["account[kana_first_name]"],
        kana_last_name: this.state["account[kana_last_name]"],
      }

      this.props.createAccount(token, accountData, fileData)
    } else {
    }
  }


  confirmModalOk = () => {
    if (this.state.formStep == 1) {
      this.generateToken()
    } else if (this.state.formStep == 2) {
      this.setState({ formStep: 3,confirmModal: false, openModal: false })
      // this.submitAction(this.state.bankToken)
    } else {
      this.submitAction(this.state.bankToken)
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    if (this.checkAllEnter()) {
      
      this.openConfirmModal()
    } else {
      this.setState({ modalMessage: '未入力の必須項目があります', openModal: true, modalHeader: 'エラー'})
    }
  }

  backStep = () => {
    switch (this.state.formStep) {
      case 1:
        break;
    
      default:
        this.setState({ formStep: this.state.formStep - 1 })
        break;
    }
  }

  keyDown = (e) => {
    this.setState({ lastKeyPush: e.keyCode })
  }

  kanaState = (e) => {
    // console.log('kanaState', this.state.lastKeyPush)  
    let newState = {}

    if (e.target.getAttribute('data-translate-hiragana-target') && e.target.getAttribute('data-translate-history')) {
      let targetInput = document.getElementsByName(e.target.getAttribute('data-translate-hiragana-target'))

      if (targetInput.length > 0) {

        targetInput = targetInput[0]

        let newHistory = this.state[e.target.getAttribute('data-translate-history')]

        const oldHistory = this.state[e.target.getAttribute('data-translate-history')]

        const lastHistory = oldHistory[oldHistory.length - 1]

        if (this.state.lastKeyPush !== null) {
          if (this.state.lastKeyPush !== 8) {
            // backspace 以外

            if (lastHistory !== e.target.value) {
              // 変更があった時だけ
              const ua = window.navigator.userAgent
              const isIphone = ua && /iPhone/.test(ua)
              if (!(e.target.value === '' && isIphone)) {
                // 新しいvalue === 0
                newHistory = newHistory.concat(e.target.value)
              }
            }

          } else {
            // backspaceの時
            let newValue = e.target.value

            if (lastHistory && lastHistory.length - e.target.value.length <= 1) {
              // newValue = e.target.value.slice(0, e.target.value.length - 1)
              // console.log('１文字削除', lastHistory, e.target.value, newValue)
            }

            if (newValue === '') {
              newHistory = []
            } else {
              newHistory = newHistory.concat(newValue)
            }
          }
        }


        const newKana = historykana(newHistory, { kanaRegexp: /^[ 　ぁあ-んー0-9\-]*$/ })


        newState = {...newState, [e.target.getAttribute('data-translate-history')]: newHistory, [e.target.getAttribute('data-translate-hiragana-target')]: newKana}

        this.setState(newState)
        // console.log('new state',newHistory[newHistory.length - 1], newKana, newHistory)
      }
    }
  }

  valueChange = (e) => {

    this.kanaState(e)

    let newState = {
      [e.target.name]: e.target.value
    }

    if (e.target.getAttribute('data-hiragana')) {
      const isHiragana = this.isHiragana(e.target.value)
      if (isHiragana) {
        e.target.parentNode.classList.remove('with_error')
      } else {
        e.target.parentNode.classList.add('with_error')
      }
    }

    if (e.target.getAttribute('data-postal')) {
      const isPostal = this.isPostcode(e.target.value)
      if (isPostal) {
        e.target.parentNode.classList.remove('with_error')
      } else {
        e.target.parentNode.classList.add('with_error')
      }
    }

    if (e.target.getAttribute('data-number')) {
      const isNum = this.isNumber(e.target.value)
      if (isNum) {
        e.target.parentNode.classList.remove('with_error')
      } else {
        e.target.parentNode.classList.add('with_error')
      }
    }

    if (e.target.name === "file") {
      const filePreviewBox = document.getElementById('img-prev-area')
      const fileInput = e.target
      const previewImage = document.querySelector('.preview-image')

      const file = fileInput.files[0]
      const isValidFile = !!file ? this.validateFileExtensions(file) : false

      if (!fileInput.files.length || !isValidFile) {
        filePreviewBox.classList.remove('previewed')
        previewImage.classList.add('d-none')
        previewImage.src = ''
        e.target.value = ''

      } else {
        filePreviewBox.classList.add('previewed')

        let fileReader = new FileReader();

        fileReader.onload = () => {
          // filePreviewBox.style.backgroundImage = `url(${fileReader.result})`
          previewImage.src = fileReader.result
          previewImage.classList.remove('d-none')
          this.windowSizeFetch()
        }
        fileReader.readAsDataURL(fileInput.files[0])
        fileReader.onload()
      }
    }

    this.setState(newState)
  }

  validateFileExtensions = (file) => {
    var validFileExtensions = ["jpg", "jpeg", "gif", "png"];
    var fileErrors = new Array();

    var ext = file.name.split('.').pop();

    if (validFileExtensions.indexOf(ext) == -1) {
      fileErrors.push('画像は jpg, jpeg, gif, png のいずれかのフォーマットのものを選択する必要があります。')
    }

    if (file.size >= SG.FILE_SIZE_LIMIT) {
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
      let ext = sizes[0];
      let size = SG.FILE_SIZE_LIMIT

      if (typeof size === 'number') {
        for (var i = 1; i < sizes.length; i += 1) {
          if (size >= 1024) {
            size = size / 1024;
            ext = sizes[i];
          }
        }
      }

      const limit = this.round(size, 2) + ext;

      fileErrors.push(`ファイルの容量が大きすぎます。 ${limit} 以下のサイズのファイルを選択して下さい。`)
    }

    if (fileErrors.length > 0) {
      this.props.noticeAddForBank(fileErrors, 'error')
      return false;
    }
    return true;
  }

  round = (value, precision, mode) => {

    var m, f, isHalf, sgn; // helper variables
    precision |= 0; // making sure precision is integer
    m = Math.pow(10, precision);
    value *= m;
    sgn = (value > 0) | -(value < 0); // sign of the number
    isHalf = value % 1 === 0.5 * sgn;
    f = Math.floor(value);

    if (isHalf) {
      switch (mode) {
        case 'PHP_ROUND_HALF_DOWN':
          value = f + (sgn < 0); // rounds .5 toward zero
          break;
        case 'PHP_ROUND_HALF_EVEN':
          value = f + (f % 2 * sgn); // rouds .5 towards the next even integer
          break;
        case 'PHP_ROUND_HALF_ODD':
          value = f + !(f % 2); // rounds .5 towards the next odd integer
          break;
        default:
          value = f + (sgn > 0); // rounds .5 away from zero
      }
    }

    return (isHalf ? value : Math.round(value)) / m;

  }

  fileInputClick = () => {
    const fileInput = document.querySelector('.account-document-input')
    fileInput.click()
  }

  render = () => {
    const currentUser = this.props.App.currentUser
    const currentPath = this.props.router.location.pathname
    let modal
    if (this.state.confirmModal) {
      modal = (
        <Modal
          okClickHandler={this.confirmModalOk}
          headerTitle='登録内容の確認'
          isOpen={this.state.openModal}
          closeModal={this.closeModal}
          okText={this.state.formStep == 3 ? '登録' : '次へ'}
          cancelText='戻る'
          noIcon={true}
        >
          <table className='table small'>
            <tbody>
              <tr>
                <td colSpan='2'><h3 className='mb0 color-gray'>口座情報</h3></td>
              </tr>
              <tr>
                <th width='50'>銀行番号</th>
                <td>{this.state["bank[bank_number]"]}</td>
              </tr>
              <tr>
                <th>支店番号</th>
                <td>{this.state["bank[branch_number]"]}</td>
              </tr>
              <tr>
                <th>口座番号</th>
                <td>{this.state["bank[account_number]"]}</td>
              </tr>
              <tr>
                <th>口座名義</th>
                <td>{this.state["bank[account_holder_name]"]}</td>
              </tr>
            </tbody>
          </table>
          {(() => {
            if (this.state.formStep > 1) {
              return (
                <table className='table small'>
                  <tbody>
                    <tr>
                      <td colSpan='2'>
                        <h3 className='mb0 color-gray'>住所</h3>
                      </td>
                    </tr>
                    <tr>
                      <th>漢字</th>
                      <td>〒{this.state["account[postal_code]"]}
                        {this.state["account[kanji_state]"]} {this.state["account[kanji_city]"]} {this.state["account[kanji_town]"]}{this.state["account[kanji_line1]"]}{this.state["account[kanji_line2]"]}</td>
                    </tr>
                    <tr>
                      <th>ふりがな</th>
                      <td>〒{this.state["account[postal_code]"]}
                        {this.state["account[kana_state]"]} {this.state["account[kana_city]"]} {this.state["account[kana_town]"]} {this.state["account[kana_line1]"]} {this.state["account[kana_line2]"]}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )
            }
          })()}
          {(() => {
            if (this.state.formStep > 2) {
              return (
                <table className='table small'>
                  <tbody>
                    <tr>
                      <td colSpan='2'><h3 className='mb0 color-gray'>本人情報</h3></td>
                    </tr>
                    <tr>
                      <th>氏名</th>
                      <td>{this.state["account[kanji_first_name]"]} {this.state["account[kanji_last_name]"]}</td>
                    </tr>
                    <tr>
                      <th>ふりがな</th>
                      <td>{this.state["account[kana_first_name]"]} {this.state["account[kana_last_name]"]}</td>
                    </tr>
                    <tr>
                      <th>身分証明書の画像</th>
                      <td>
                        <img src={this.state.modalPreviewSrc} alt='' className='preview-image-confirm preview-image' />
                      </td>
                    </tr>
                  </tbody>
                </table>
              )
            }
          })()}

        </Modal>
      )
    } else {
      modal = (
        <Modal
          okClickHandler={null}
          headerTitle={this.state.modalHeader}
          isOpen={this.state.openModal}
          closeModal={this.closeModal}
          okText={null}
          cancelText='戻る'
        >
          <p>{this.state.modalMessage}</p>
        </Modal>
      )
    }


    const metaInfo = (
      <Helmet>
        <title>銀行口座情報 | {SG.META_TITLE}</title>
        <meta name='description' content='銀行口座情報です。' />
      </Helmet>
    )

    const photo = !!this.state['file'] ? this.state['file'] : "";
    const photoClass = (!!photo) ? 'previewed' : ''

    let headline, body, notice, btns

    switch (this.state.formStep) {
      case 1:
        headline = '銀行口座登録'
        notice = (
          <p>
            作成したサークルからの収益を受け取るためには、Stripeサービス内で口座情報を登録する必要があります。<br />このページで必要事項を入力して送信して下さい。
          </p>
        )
        
        body = (
          <form onSubmit={this.onSubmit} className='form bank-form text-left'>
            <h3 className='sub-headline'>口座情報</h3>
            <div className='row'>
              <div className='field col-6'>
                <label htmlFor="bank[bank_number]" className="need-icon">銀行番号</label>
                <input type="text" name="bank[bank_number]" value={this.state['bank[bank_number]']} onChange={this.valueChange} placeholder='0001' data-number={true} />
              </div>
              <div className='field col-6'>
                <label htmlFor="bank[branch_number]" className="need-icon">支店番号</label>
                <input type="text" name="bank[branch_number]" value={this.state['bank[branch_number]']} placeholder='564' onChange={this.valueChange} data-number={true} />
              </div>
            </div>
            <div className='field'>
              <label htmlFor="bank[account_number]" className="need-icon">口座番号</label>
              <input type="text" name="bank[account_number]" value={this.state['bank[account_number]']} onChange={this.valueChange} placeholder='1234567' data-number={true} />
            </div>
            <div className='field'>
              <label htmlFor="bank[account_holder_name]" className="need-icon">口座名義</label>
              <input type="text" name="bank[account_holder_name]" value={this.state['bank[account_holder_name]']} onChange={this.valueChange} placeholder='ヤマダハナコ' />
            </div>
          </form>
        )
        if (this.checkAllEnter()) {
          btns = (
            <input type='submit' value='確認' className='btn btn-white btn-bordered' onClick={this.onSubmit} />
          )
        } else {
          btns = (
            <input type='submit' value='確認' className='disabled btn btn-white btn-bordered' disabled={true} />
          )
        }
        break;
      case 2:
        headline = '続いて' + currentUser.name + 'さんの情報を教えてください'
        body = (
          <form onSubmit={this.onSubmit} className='h-adr form account-form text-left'>
            <input type="hidden" className="p-country-name" value="Japan" />
            {/* <input type="text" className='p-region' id="pref" />
            <input type="text" className='p-locality' id="city" />
            <input type="text" className='p-street-address' id="area" />
            <input type="text" className='p-extended-address' id="addr" /> */}
            <h3 className='sub-headline'>住所</h3>
            <div className='field'>
              <label htmlFor="account[postal_code]" className="need-icon">郵便番号(ハイフンなし)</label>
              <input id='zip' className='p-postal-code' type="text" name="account[postal_code]" value={this.state['account[postal_code]']} onChange={this.valueChange} placeholder='1231234' onBlur={this.onBlurZipcode} data-postal={true} />
            </div>
            <div className='row'>
              <div className='field col-6'>
                <label htmlFor="account[kanji_state]" className="need-icon">都道府県</label>
                <input id="pref" type="text" name="account[kanji_state]" value={this.state['account[kanji_state]']} onChange={this.valueChange}  onKeyDown={this.keyDown} placeholder='東京都' data-translate-hiragana-target='account[kana_state]' data-translate-history='stateHistory' />
              </div>
              <div className='field col-6'>
                <label htmlFor="account[kana_state]" className="need-icon">都道府県(かな)</label>
                <input type="text" id='kana_state' name="account[kana_state]" value={this.state['account[kana_state]']} onChange={this.valueChange} placeholder='とうきょうと' data-hiragana={true} />
              </div>
            </div>
            <div className='row'>
              <div className='field col-6'>
                <label id="city" htmlFor="account[kanji_city]" className="need-icon">市区町村</label>
                <input type="text" name="account[kanji_city]" value={this.state['account[kanji_city]']} onChange={this.valueChange} placeholder='渋谷区' onKeyDown={this.keyDown}  data-translate-hiragana-target='account[kana_city]' data-translate-history='cityHistory' />
              </div>
              <div className='field col-6'>
                <label htmlFor="account[kana_city]" className="need-icon">市区町村(かな)</label>
                <input type="text" name="account[kana_city]" value={this.state['account[kana_city]']} onChange={this.valueChange} placeholder='しぶやく' data-hiragana={true} />
              </div>
            </div>

            <div className='row'>
              <div className='field col-6'>
                <label htmlFor="account[kanji_town]" className="noneed-icon">大字</label>
                <input id='area' type="text" name="account[kanji_town]" value={this.state['account[kanji_town]']} onChange={this.valueChange} placeholder='恵比寿' onKeyDown={this.keyDown} data-translate-hiragana-target='account[kana_town]' data-translate-history='townHistory'  />
              </div>
              <div className='field col-6'>
                <label htmlFor="account[kana_town]" className="noneed-icon">住所(かな)</label>
                <input type="text" name="account[kana_town]" value={this.state['account[kana_town]']} onChange={this.valueChange} placeholder='えびす' data-hiragana={true} />
              </div>
            </div>

            <div className='row'>
              <div className='field col-6'>
                <label htmlFor="account[kanji_line1]" className="need-icon">丁・番地</label>
                <input id='addr' type="text" name="account[kanji_line1]" value={this.state['account[kanji_line1]']} onChange={this.valueChange} placeholder='1-1-1' onKeyDown={this.keyDown} data-translate-hiragana-target='account[kana_line1]' data-translate-history='line1History' />
              </div>
              <div className='field col-6'>
                <label htmlFor="account[kana_line1]" className="need-icon">丁・番地(かな)</label>
                <input type="text" name="account[kana_line1]" value={this.state['account[kana_line1]']} onChange={this.valueChange} placeholder='1-1-1' data-hiragana={true} />
              </div>
            </div>

            <div className='row'>
              <div className='field col-12'>
                <label htmlFor="account[kanji_line2]" className="noneed-icon">建物名</label>
                <input type="text" name="account[kanji_line2]" value={this.state['account[kanji_line2]']} onChange={this.valueChange} placeholder='●●ビルディング101号室' onKeyDown={this.keyDown} data-translate-hiragana-target='account[kana_line2]' data-translate-history='line2History' />
              </div>
              <div className='field col-12'>
                <label htmlFor="account[kana_line2]" className="noneed-icon">建物名(かな)</label>
                <input type="text" name="account[kana_line2]" value={this.state['account[kana_line2]']} onChange={this.valueChange} placeholder='●●びるでぃんぐ101ごうしつ' data-hiragana={true} />
              </div>
            </div>
          </form>
        )
        if (this.checkAllEnter()) {
          btns = (
            <div className='row'>
              <div className='col-6'>
                <input type='submit' value='戻る' className='btn btn-white btn-bordered' onClick={this.backStep} />
              </div>
              <div className='col-6'>
                <input type='submit' value='確認' className='btn btn-white btn-bordered' onClick={this.onSubmit} />
              </div>
            </div>
          )
        } else {
          btns = (
            <div className='row'>
              <div className='col-6'>
                <input type='submit' value='戻る' className='btn btn-white btn-bordered' onClick={this.backStep} />
              </div>
              <div className='col-6'>
                <input type='submit' value='確認' className='disabled btn btn-white btn-bordered' disabled={true} />
              </div>
            </div>
          )
        }
        break;
      case 3:
        headline = '最後のステップです'
        body = (
          <form onSubmit={this.onSubmit} className='form file-form text-left'>

            <h3 className='sub-headline'>本人情報</h3>

            <div className='row'>
              <div className='field col-6'>
                <label htmlFor="account[kanji_first_name]" className="need-icon">姓</label>
                <input type="text" name="account[kanji_first_name]" value={this.state['account[kanji_first_name]']} onChange={this.valueChange} placeholder='山田' onKeyDown={this.keyDown} data-translate-hiragana-target='account[kana_first_name]' data-translate-history='firstNameHistory' />
              </div>
              <div className='field col-6'>
                <label htmlFor="account[kanji_last_name]" className="need-icon">名</label>
                <input type="text" name="account[kanji_last_name]" value={this.state['account[kanji_last_name]']} onChange={this.valueChange} placeholder='花子' onKeyDown={this.keyDown} data-translate-hiragana-target='account[kana_last_name]' data-translate-history='lastNameHistory'/>
              </div>
            </div>
            <div className='row'>
              <div className='field col-6'>
                <label htmlFor="account[kana_first_name]" className="need-icon">姓(かな)</label>
                <input type="text" name="account[kana_first_name]" value={this.state['account[kana_first_name]']} onChange={this.valueChange} placeholder='やまだ' data-hiragana={true} />
              </div>
              <div className='field col-6'>
                <label htmlFor="account[kana_last_name]" className="need-icon">名(かな)</label>
                <input type="text" name="account[kana_last_name]" value={this.state['account[kana_last_name]']} onChange={this.valueChange} placeholder='はなこ' data-hiragana={true} />
              </div>
            </div>
            <div className='field'>
              <label htmlFor="file" className="need-icon">写真付き身分証明書の画像</label>

              <div id='img-prev-area' className={photoClass} onClick={this.fileInputClick}>
                <input type='file' name='file' className='d-none thumb-field account-document-input' onChange={this.valueChange} accept=".jpg,.gif,.png,image/gif,image/jpeg,image/png" />
                <img src={photo} alt='' className='preview-image' />
              </div>
            </div>
            <div className='checkbox-wrap' >
              <input id='StripeCheck' type='checkbox' value="1" checked={this.props.confirmStripe} onChange={this.valueChange} name="confirmStripe" />
              <label htmlFor='StripeCheck' >Stripeの利用規約に同意する</label>
            </div>
          </form>
        )
        if (this.checkAllEnter()) {
          btns = (
            <div className='row'>
              <div className='col-6'>
                <input type='submit' value='戻る' className='btn btn-white btn-bordered' onClick={this.backStep} />
              </div>
              <div className='col-6'>
                <input type='submit' value='送信' className='btn btn-primary btn-bordered' onClick={this.onSubmit} />
              </div>
            </div>
          )
        } else {
          btns = (
            <div className='row'>
              <div className='col-6'>
                <input type='submit' value='戻る' className='btn btn-white btn-bordered' onClick={this.backStep} />
              </div>
              <div className='col-6'>
                <input type='submit' value='送信' className='disabled btn btn-primary btn-bordered' disabled={true} />
              </div>
            </div>
          )
        }
        break
      case 4: // 申請済み
        headline = '口座情報の申請済みです'
        body = (
          <div>
            <p>Stripeに口座情報を送信済みです。<br />承認処理が完了するまで少々お待ち下さい。</p>
          </div>
        )
        break;
      case 5: // 承認済み
        headline = '口座情報の承認済みです'
        const account = this.props.UserBank.userAccount
        body = (
          <div>
            <table className='table'>
              <tbody>
                <tr>
                  <th>口座情報</th>
                  <td>
                    <p>銀行名：{account.bank_name}</p>
                    <p>支店番号：{account.branch_number}</p>
                    <p>口座番号：{account.bank_number}</p>
                    <p>名義：{account.account_holder_name}</p>
                  </td>
                </tr>
                <tr>
                  <th>個人情報</th>
                  <td>
                    <p>氏名：{account.kanji_first_name} {account.kanji_last_name}</p>
                    <p>住所：〒{account.postal_code}<br />{account.kanji_state}{account.kanji_city}{account.kanji_town}{account.kanji_line1}{account.kanji_line2}</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>現在上記口座が登録されています。<br />こちらの口座あてに作成したサークルからの収益が入金されます。</p>
          </div>
        )
        
      default:
        break;
    }



    return (
      <div className='container'>
        {metaInfo}
        {ReactDOM.createPortal(modal, document.getElementById('dialogSpace'))}
        <UserCard user={currentUser} bankEditHide={true} />
        <h2 className='headline mt0'>{headline}</h2>
        <nav>
          <ol className='multi-steps'>
            <li className={this.state.formStep == 1 ? 'current' : 'visited'}><span>口座情報</span></li>
            <li className={this.state.formStep > 2 ? 'visited' : this.state.formStep == 2 ? 'current' : ''}><span>住所情報</span></li>
            <li className={this.state.formStep >= 3 ? 'visited' : ''}><span>本人情報</span></li>
          </ol>
        </nav>
        <p className='notice-text'>{notice}</p>
        {body}
        <div className='row'>
          <div className='mt15 col-12 col-sm-4'>
            {btns}
          </div>
          <div className='mt15 col-12 col-sm-4'>
            <Link to={RT.USER_MYPAGE_PATH} className='btn btn-default btn-bordered btn-block'>マイページに戻る</Link>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/User/Bank/Bank.jsx